module.exports = __webpack_public_path__ + "d53eb9e143ce6c3ef8947df720dc843c.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1153
// module chunks = 0